export default defineAppConfig({
  theme: 'blurple' as Theme,
})
